'use client';

import React from 'react';

import { useBack } from '@/hooks/useBack';

type ScreenProps = {
  children: React.ReactNode;
};

const Screen: React.FC<ScreenProps> = (props) => {
  const { children } = props;
  useBack();

  return <main className="h-screen">{children}</main>;
};

export default Screen;
